export default "__VITE_ASSET__2b497d8d__"